import React, { useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import PulpyTextField from 'components/pulpyTextField';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Tick from 'assets/tick.svg';
import Download from 'assets/download.svg';
import { isNotValidEmail } from 'utils/validation';
import FormHelperText from '@mui/material/FormHelperText';
import {
  // templateAtom,
  detailsAtom,
  verifyStatusAtom,
  // stylesAtom,
  tabValueAtom,
  meetingDetailsAtom,
} from '_state/signature';

import { useUserActions, useEffectAfterMount } from 'hooks';

// import { getTemplate } from 'components/templates/template';
// import ReactDOMServer from 'react-dom/server';

const Verification = () => {
  const userActions = useUserActions();
  const navigate = useNavigate();
  const details = useRecoilValue(detailsAtom);
  const meetingDetails = useRecoilValue(meetingDetailsAtom);

  const verifyStatus = useRecoilValue(verifyStatusAtom);
  // const template = useRecoilValue(templateAtom);
  // const styles = useRecoilValue(stylesAtom);
  const tabValue = useRecoilValue(tabValueAtom);
  const [loading, setLoading] = useState(false);

  useEffectAfterMount(() => {
    if (verifyStatus.status === 200 || verifyStatus.status === 201) {
      if (tabValue === 'Email Signature') navigate('/download', { replace: true });
      else navigate('/download-meeting-signature', { replace: true });
      // localStorage.setItem('verifyStatus', 'true');
    } else {
      alert('Something went wrong');
    }
    setLoading(false);
  }, [verifyStatus]);

  const [state, updateState] = useReducer(
    (prev: any, next: any) => {
      const newEvent = { ...prev, ...next };

      if (newEvent.nameError && next.name) newEvent.nameError = false;

      if (newEvent.emailError && !isNotValidEmail(newEvent.workEmail)) newEvent.emailError = false;

      return newEvent;
    },
    {
      name: getName(),
      nameError: false,
      workEmail:
        tabValue === 'Email Signature'
          ? details?.contactInfo?.workEmail ?? ''
          : meetingDetails?.contactInfo?.workEmail ?? '',
      emailError: false,
    },
  );

  function getName() {
    if (tabValue === 'Email Signature') return details?.personalInfo?.fullName ?? '';
    else
      return meetingDetails?.personalInfo?.firstName || meetingDetails?.personalInfo?.lastName
        ? meetingDetails?.personalInfo?.firstName + ' ' + meetingDetails?.personalInfo?.lastName
        : '';
  }

  const onchangeValues = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const value = e.target.value;
    updateState({ [name]: value });
  };

  const onSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    let obj = null;
    if (!state.name) {
      obj = { nameError: true };
    }
    if (isNotValidEmail(state.workEmail)) {
      obj = { ...obj, emailError: true };
    }
    if (obj) {
      updateState({ ...obj });
      return;
    }

    const payload = {
      name: state.name,
      email: state.workEmail,
      metadata: {
        signature: tabValue === 'Email Signature' ? 'email' : 'meeting',
        personalInfo: {},
        contactInfo: {},
        socialMedialLinks: {},
      },
      // signature: tabValue === 'Email Signature' ? 'email' : 'meeting',
      // personalInfo: {},
      // contactInfo: {},
      // socialMedialLinks: {},
      // // emailSignature: {},
      // // meetingSignature: {},
      // // details,
      // // template: ReactDOMServer.renderToString(getTemplate(details, styles, template)),
    };

    if (tabValue === 'Email Signature') {
      payload.metadata.personalInfo = details.personalInfo;
      payload.metadata.contactInfo = details.contactInfo;
      payload.metadata.socialMedialLinks = details.socialMedialLinks;
      // payload.emailSignature = {
      //   details,
      //   // template: ReactDOMServer.renderToString(getTemplate(details, styles, template)),
      // };
    } else {
      payload.metadata.personalInfo = {
        ...meetingDetails.personalInfo,
        logo: '',
      };
      payload.metadata.contactInfo = meetingDetails.contactInfo;
      payload.metadata.socialMedialLinks = meetingDetails.socialMedialLinks;
      // payload.meetingSignature = {
      //   details: {
      //     ...meetingDetails,
      //     personalInfo: {
      //       ...meetingDetails.personalInfo,
      //       logo: '',
      //     },
      //   },
      // };
    }

    // if (tabValue === 'Email Signature') navigate('/download', { replace: true });
    // else navigate('/download-meeting-signature', { replace: true });

    setLoading(true);
    userActions.verifyUser(payload);
  };

  return (
    <div className="row h-100 justify-content-center align-items-center">
      <div className="col-lg-4 text-center">
        <Box pb={5} display="flex" justifyContent={'space-between'}>
          <Avatar
            sx={{
              width: '50px',
              height: '50px',
              border: '1px solid #23BB86',
              borderRadius: '50%',
              padding: 1.8,
              mr: 1,
            }}
            variant="rounded"
            alt=""
            src={Tick}
          />
          <Box
            sx={{
              width: '100%',
              borderTop: '2px dotted #23BB86',
              margin: '20px 2px 0 2px',
              transform: 'rotate(-0.07deg)',
            }}
          />
          <Avatar
            sx={{
              width: '50px',
              height: '50px',
              border: '1px solid #C4C4C4',
              borderRadius: '50%',
              padding: 1.5,
              ml: 1,
            }}
            variant="rounded"
            alt=""
            src={Download}
          />
        </Box>

        <Paper elevation={0} sx={{ background: '#F7F7F7', px: 3, py: 5 }}>
          <Typography variant="body2" gutterBottom>
            VERIFICATION
          </Typography>
          <Typography sx={{ py: 3 }} className="mx-auto col-md-9" variant="h6" gutterBottom>
            Verify yourself to get your new email signature
          </Typography>
          <form onSubmit={onSubmit} noValidate>
            <FormControl variant="standard" fullWidth>
              <InputLabel shrink htmlFor="name" className="form-label">
                Your Name
              </InputLabel>
              <PulpyTextField
                name="name"
                id="name"
                value={state.name}
                onChange={onchangeValues}
                fullWidth
              />
              <FormHelperText className="Mui-error">
                {state.nameError ? 'Please enter name' : ''}
              </FormHelperText>
            </FormControl>
            <FormControl variant="standard" fullWidth className="mt-3">
              <InputLabel shrink htmlFor="workEmail" className="form-label">
                Your Work Email
              </InputLabel>
              <PulpyTextField
                name="workEmail"
                id="workEmail"
                onChange={e => updateState({ workEmail: e.target.value })}
                fullWidth
                value={state.workEmail}
              />{' '}
              <FormHelperText className="Mui-error">
                {state.emailError ? 'Please enter valid email' : ''}
              </FormHelperText>
            </FormControl>

            <FormControl variant="standard" fullWidth className="mt-4">
              <Button
                sx={{
                  textTransform: 'none',
                  '&.MuiButtonBase-root:hover': {
                    bgcolor: '#FF8140',
                  },
                }}
                type="submit"
                variant="contained"
                color="secondary"
                disabled={loading}
              >
                {loading ? 'Loading..' : 'Get the Signature'}
              </Button>
            </FormControl>
          </form>
          <Typography variant="caption" display="block" className="mt-3" gutterBottom>
            We'll use the information you provide to send you relevant content. You can unsubscribe
            whenever you want. See our Privacy Policy.
          </Typography>
        </Paper>
      </div>
    </div>
  );
};

export default Verification;
